import { useCallback } from 'react';

import { useSetState } from '../store/selectors.js';

export const useToolbar = () => {
  const setState = useSetState();

  const setTooltipHoverState = useCallback(
    (isHovered: boolean) => {
      setState((prev) => ({
        ...prev,
        toolbar: {
          isHovered,
        },
      }));
    },
    [setState],
  );
  return {
    setTooltipHoverState,
  };
};
